import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('homebattery');
    const lists: any = [
        {
            title: t('secG_q1'),
            desc: t.rich('secG_a1', {
                a: (text: string) => (
                    <Link href={text} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secG_q2'),
            desc: t('secG_a2'),
        },
        {
            title: t('secG_q3'),
            desc: t('secG_a3'),
        },
        {
            title: t('secG_q4'),
            desc: t('secG_a4'),
        },
        {
            title: t('secG_q5'),
            desc: t('secG_a5'),
        },
    ];
    return (
        <div id="home-battery-G" className={`home-battery-G home-battery-box ${css['home-battery-G']}`}>
            <p className="title">{t('secG_title')}</p>
            <Collapse
                ghost={true}
                className="collapse-lists"
                defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
